import { FunctionComponent } from "react";
import SvgIcon from "../SvgIcon";
import { ReactComponent as Icon } from "./Profile.svg";


const IconProfile: FunctionComponent = () => {
  return <SvgIcon svg={<Icon />} />;
};

export default IconProfile;
